import $ from "jquery";
import ProductGallery from "@js/product/components/ProductGallery";
function activateFirstProductTab() {
  $(".product-tabs .nav .nav-item:first-child a").tab("show");
  $(".product-tabs .btn-product-tab").first().addClass("active");
}
function handleProductDetailsToggle() {
  const $link = $('[href="#product-details"]');
  const $tab = $($link.attr("href"));
  if ($tab.length && $link.length && $link.hasClass("active")) {
    $tab.addClass("show active");
  }
}
$(() => {
  activateFirstProductTab();
  const gallery = new ProductGallery();
  gallery.init();
  prestashop.on("updatedProductCombination", (event) => {
    gallery.init();
    const { product_add_to_cart: productAddToCart } = event;
    if (productAddToCart) {
      const node = document.createElement("div");
      node.innerHTML = productAddToCart;
      const html = node.querySelector(".js-product-actions-buttons");
      if (html) {
        const productActionsElement = document.querySelector(".js-product-actions-buttons");
        productActionsElement.replaceWith(html);
      }
    }
  });
  prestashop.on("updatedProduct", () => {
    handleProductDetailsToggle();
  });
});
$(document).ready(() => {
  $('a[data-toggle="tab"]').on("shown.bs.tab", function(e) {
    $(".btn-product-tab").removeClass("active");
    $('.btn-product-tab[href="' + $(this).attr("href") + '"]').addClass("active");
  });
  $(".btn-product-tab").on("click", function(e) {
    const screen_position = $(window).scrollTop();
    $('.product-tabs .nav-link[href="' + $(this).attr("href") + '"]').trigger("click");
    setTimeout(() => {
      const offset = $(this).offset().top - 50;
      if (screen_position > offset) {
        $("html, body").animate({
          scrollTop: offset
        }, 100);
      }
    }, 150);
  });
});
